import { Tag } from 'primereact/tag';

export const incidenceBodyTemplate = (
  rowData,
  type,
  getIncidentPriorityColor,
  getIncidentStatusColor
) => {
  const getColor =
    type === 'priority' ? getIncidentPriorityColor : getIncidentStatusColor;

  const rawValue = String(
    rowData[type] || (type === 'status' ? 'Pendiente' : 'N/A')
  );

  return (
    <div className="pl-2">
      <Tag
        style={{
          backgroundColor:
            type === 'priority' ? 'transparent' : getColor(rawValue),
          color: type === 'priority' ? 'inherit' : 'white',
          paddingLeft: '0.5rem',
          paddingRight: '0.5rem',
          width: type === 'priority' ? 'auto' : '80px',
          whiteSpace: type === 'priority' ? 'nowrap' : 'normal',
          boxShadow: 'none',
        }}
        value={rawValue}
      />
    </div>
  );
};
